'use client'

import { FilterList } from '@/app/collection/_components/filter-bar/filter-list'
import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import { cn } from '@/lib/utils'
import { TCollectionFormatted } from '@/types/collection'
import { Settings2, X } from 'lucide-react'
import { usePathname, useRouter } from 'next/navigation'
import { useState } from 'react'
import { useCollectionStore } from '../../store/collection-store'
import { getFilterStatus } from '../../utils/filter-utils'

export const FilterBarMobile = ({
  collection,
}: {
  collection: TCollectionFormatted
}) => {
  const [open, setOpen] = useState(false)
  const router = useRouter()
  const pathname = usePathname()
  const setFilter = useCollectionStore((s) => s.setFilter)
  const filter = useCollectionStore((s) => s.filter)

  const onClearFilter = () => {
    setOpen(false)
    router.push(pathname)
    setFilter({})
  }

  const { hasFilter, filterCount } = getFilterStatus(filter, collection)

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <button
          className={cn(
            'relative flex min-w-[106px] items-center justify-between rounded-[40px] border border-neutral-300 px-3 py-2.5 font-sans text-sm leading-4 text-neutral-900',
            hasFilter && 'border-primary-500 text-primary-500'
          )}
        >
          {hasFilter && (
            <span className='mr-1 inline-flex h-5 w-5 items-center justify-center rounded-full bg-primary-100 text-xxs text-primary'>
              {filterCount}
            </span>
          )}{' '}
          Bộ lọc <Settings2 size={20} />
        </button>
      </SheetTrigger>

      <SheetContent
        side='right'
        className='scrollbar max-h-screen w-full overflow-y-auto bg-light p-0 pb-14'
        aria-describedby='mobile-filter'
        showCloseButton={false}
      >
        <SheetTitle className='hidden' />

        <SheetDescription />
        <div className='sticky top-0 flex items-center justify-between border-b border-b-neutral-300/95 bg-light px-6 pb-2.5 pt-4.5'>
          <div className='flex-1'>
            <Button
              variant='ghost'
              size={'icon'}
              onClick={() => setOpen(false)}
              className='h-7 w-7 hover:bg-transparent'
            >
              <X strokeWidth={3} size={24} className='text-neutral-900/70' />
            </Button>
          </div>

          <p className='flex-1 text-center font-criteria text-base font-medium uppercase leading-6 text-neutral-900'>
            Bộ lọc
          </p>
          <div className='flex-1 text-right'>
            <button
              className='p-2 font-sans text-sm font-semibold leading-4.5 text-primary/90'
              onClick={onClearFilter}
            >
              Xoá lọc
            </button>
          </div>
        </div>
        <div className='mt-4.5 px-6'>
          <FilterList
            filter={collection.filter}
            collection={collection}
            className='no-scrollbar static max-h-full overflow-y-auto pr-0'
            onClose={() => setOpen(false)}
          />
        </div>
        <SheetFooter />
      </SheetContent>
    </Sheet>
  )
}
